import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

import * as S from './styles';
import { formatDateToView } from 'utils/functions';

interface ScheduleInfoDynamicPageProps {
	startDate: string;
	endDate: string;
	countdown: boolean;
}

export default function ScheduleInfoDynamicPage({
	countdown,
	endDate,
	startDate
}: ScheduleInfoDynamicPageProps) {
	return startDate === '' && endDate === '' ? (
		<></>
	) : (
		<S.container>
			<S.icon>
				<FiAlertCircle />
			</S.icon>
			<div>
				<p>
					{`Agendamento: ${startDate === '' ? 'Sem data incial' : formatDateToView(startDate)} à ${endDate === '' ? 'Sem data final' : formatDateToView(endDate)}`}
				</p>
				<p>{`Contagem regressiva: ${countdown ? 'Sim' : 'Não'}`}</p>
			</div>
		</S.container>
	);
}
